jQuery(function($){
	console.log("alika");
  var $alert = $('.fui-alert[data-fui-alert]').first();
  if(!$alert.length) return;

  var isSuccess = $alert.hasClass('fui-alert-success');
  var modalClass = isSuccess ? 'elements-modal--success' : 'elements-modal--error';

  var html = $alert.html();
  var title = $alert.find('strong').first().text().trim() || (isSuccess ? 'Message envoyé avec succès' : 'Une erreur est survenue');

  var $tmp = $('<div>'+html+'</div>');
  $tmp.find('strong').first().remove();
  var bodyHtml = $tmp.html().replace(/^<br\s*\/?>/i, '').trim();

  var $backdrop = $('<div class="elements-modal__backdrop" aria-hidden="true"></div>');
  var $modal = $('<div class="elements-modal '+modalClass+'" role="dialog" aria-modal="true" aria-labelledby="elements-modal-title" aria-describedby="elements-modal-desc"></div>');
  var $dialog = $('<div class="elements-modal__dialog"></div>');
  var $close = $('<button type="button" class="elements-modal__close" aria-label="Fermer">×</button>');
  var $title = $('<h2 id="elements-modal-title" class="elements-modal__title"></h2>').text(title);
  var $text  = $('<div id="elements-modal-desc" class="elements-modal__text"></div>').html(bodyHtml);

  $dialog.append($close, $title, $text);
  $modal.append($dialog);
  $('body').append($backdrop, $modal);

  $alert.addClass('_elements-migrated');

  function openModal(){
    $('body').addClass('elements-modal-open');
    $('html').addClass('elements-modal--open');
    $modal.addClass('elements-modal--open');
    $backdrop.addClass('elements-modal--open');
    $dialog.attr('tabindex','-1').focus();
  }
  function closeModal(){
    $('body').removeClass('elements-modal-open');
    $('html').removeClass('elements-modal--open');
    $modal.removeClass('elements-modal--open');
    $backdrop.removeClass('elements-modal--open');
  }

  $close.on('click', closeModal);
  $backdrop.on('click', closeModal);
  $(document).on('keydown', function(e){
    if(e.key === 'Escape') closeModal();
  });

  openModal();
  // setTimeout(closeModal, 6000); // auto-fermeture si voulu
});